import * as React from "react";
import { forwardRef } from "react";
const SvgDarkInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 14.7721V14.7305M10 12.6888C10 10.1388 12.5 11.318 12.5 8.76847C12.5 5.38447 7.5 5.38447 7.5 8.76847", stroke: "#5A6367", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 10.0003, cy: 10.5013, r: 7.73333, stroke: "#5A6367", strokeWidth: 1.2 }));
const ForwardRef = forwardRef(SvgDarkInfo);
export { ForwardRef as ReactComponent };
